import { Component, OnInit } from '@angular/core';
import { ThemeService } from '../services/theme.service';

@Component({
    selector: 'app-theme-selector',
    template: `
    <div class="container">
    <mat-icon class="light-icon">wb_sunny</mat-icon>
    <mat-slide-toggle (change)="toggleTheme($event.checked)"  [checked]="currentTheme=='dark'">
    </mat-slide-toggle>
    <mat-icon class="dark-icon">nights_stay</mat-icon>
</div>
  `,
    styles: [`
    :host{

    }
    .container {
        margin-top:5px;
        margin-bottom:5px;
        margin-left:10px;
        display: flex;
        align-items: center;  
    }

    .light-icon{
        margin-right:5px;
    }
    .dark-icon{
        margin-left:5px;
    }
  `]
})
export class ThemeSelectorComponent {
    currentTheme: string;

    constructor(private themeService: ThemeService) { }

    ngOnInit() {
        this.currentTheme = this.themeService.getTheme();
        this.themeService.setTheme(this.currentTheme);
    }

    toggleTheme(isDarkTheme: boolean): void {
        if (isDarkTheme) {
            this.changeTheme("dark")
        } else {
            this.changeTheme("light")
        }
    }

    changeTheme(theme: string) {
        this.currentTheme = theme;
        this.themeService.setTheme(theme);
    }
}
